import { render, staticRenderFns } from "./RegisterLayout.vue?vue&type=template&id=31e296be&"
import script from "./RegisterLayout.vue?vue&type=script&lang=js&"
export * from "./RegisterLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLayout.vue?vue&type=style&index=0&id=31e296be&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e296be')) {
      api.createRecord('31e296be', component.options)
    } else {
      api.reload('31e296be', component.options)
    }
    module.hot.accept("./RegisterLayout.vue?vue&type=template&id=31e296be&", function () {
      api.rerender('31e296be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/RegisterLayout.vue"
export default component.exports